var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Watch } from 'vue-property-decorator';
import { getVideosCRM } from '@/shared/utils/Infosets.utils';
import { NotificationService } from '@/services/NotificationService';
import { verifyMeetimeToken } from '@/clients/crm';
import Modal from 'components/Modal.vue';
import Tooltip from 'components/Tooltip.vue';
import CrmCardContent from 'components/CrmCardContent.vue';
let MeetimeConfigCard = class MeetimeConfigCard extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.token = '';
        this.tokenVerified = false;
        this.ocultedToken = true;
        this.openModal = false;
        this.crmIcon = 'statics/images/logos/meetime-logo.png';
        this.companyFields = [
            'Razão Social',
            'CNPJ',
            'Origem',
            'Website',
            'Endereço',
            'Facebook',
            'Decisores',
            'Cnae Primário',
            'Todos os Telefones',
            'Email do tomador de decisão',
            'Cargo do tomador de decisão',
            'LinkedIn do tomador de decisão',
            'Faixa de Faturamento da Empresa',
            'Faixa de Funcionarios da Empresa',
            'Primeiro nome do tomador de decisão',
            'Nome completo do tomador de decisão',
        ];
        this.questions = [
            {
                question: 'Quais planos permitem exportação?',
                answer: 'Todos os planos pagos',
            },
            {
                question: 'Onde ficam os dados de empresa e decisores?',
                answer: 'No menu superior passe o mouse por Prospecção e depois clique Leads',
            },
            {
                question: 'O que acontece se eu exportar 2 vezes a mesma empresa?',
                answer: 'Nosso integrador irá duplicar o lead',
            },
        ];
        this.observations = [
            'Para que o campo CNPJ seja enviado para sua conta no meetime, precisa cria um campo customizado com o nome CNPJ.',
            'A estrutura de envios para o Meetime é diferente dos demais CRMs, nessa estrutura é enviado um único decisor da empresa e a informação de empresa e decisor sobem juntas em um único lead.',
            'Os dados de decisor e da empresa está disponível em "Anotações" na aba "histórico" após clicar na empresa. E pode ser encontrado na aba de "Dados".',
        ];
    }
    get tutorialVideoLink() {
        return getVideosCRM('meetime');
    }
    changedOpenModal() {
        this.ocultedToken = true;
    }
    async verifyToken() {
        this.loading = true;
        try {
            await verifyMeetimeToken({ token: this.token });
            this.tokenVerified = true;
            this.ocultedToken = true;
            NotificationService.success('Sucesso', 'Seu token foi salvo com sucesso. Agora você pode exportar para o crm!');
        }
        catch (e) {
            NotificationService.error('Error', 'O token selecionado está inválido');
        }
        this.loading = false;
    }
    changeToken() {
        this.token = '';
        this.tokenVerified = false;
    }
};
__decorate([
    Watch('openModal')
], MeetimeConfigCard.prototype, "changedOpenModal", null);
MeetimeConfigCard = __decorate([
    Component({
        name: 'MeetimeConfigCard',
        components: {
            Modal,
            Tooltip,
            CrmCardContent,
        },
    })
], MeetimeConfigCard);
export default MeetimeConfigCard;
